export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 pb-6 border-b border-slate-200 mb-6">
      <div>
        {eyebrow && (
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-slate-500 mb-2">{eyebrow}</div>
        )}
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
        {description && <p className="text-sm text-slate-500 mt-1.5">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
